import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import ReasonSelectorView from './ReasonSelectorView.vue'
import ReasonSelectorPreviewText from './ReasonSelectorPreviewText.vue'

const TransformReasonSelector = transformComponent(ReasonSelectorView, {
  change: 'input',
})

export const ReasonSelector = connect(
  TransformReasonSelector,
  mapProps(
    {
      readOnly: 'readonly',
      disabled: 'disabled',
    },
    props => {
      return {
        options: props.options || [],
        shouldValidate: props.shouldValidate || false,
      }
    },
  ),
  mapReadPretty(ReasonSelectorPreviewText),
)

export default ReasonSelector
